import { render } from "./UserSettingsSystem.vue?vue&type=template&id=080da568"
import script from "./UserSettingsSystem.vue?vue&type=script&lang=js"
export * from "./UserSettingsSystem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__